import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api, type ApiResponse } from '@/lib/api';
import type { FormType } from '@troia-v3/types';

/** Item cru retornado por `GET /api/forms/dropdown?type=` (backend Task 6). */
interface FormDropdownItem {
  id: string;
  name: string;
}

export interface FormDropdownOption {
  value: string;
  label: string;
}

/**
 * Hook para listar formulários/checklists ATIVOS em formato de dropdown.
 * Usa `GET /api/forms/dropdown?type=form|checklist` — rota cross-module sem
 * `permissionMiddleware` (só app + auth).
 *
 * `enabled` (default `true`) — condicionar a `isOpen` em modais/drawers evita
 * disparar a query com o componente fechado (CLAUDE.md SEMPRE #10).
 */
export const useFormsDropdown = (
  type: FormType,
  enabled: boolean = true
): UseQueryResult<FormDropdownOption[], Error> => {
  return useQuery({
    queryKey: ['forms-dropdown', type],
    queryFn: async () => {
      const response = await api.get<ApiResponse<FormDropdownItem[]>>('/forms/dropdown', { params: { type } });
      return (response.data.data ?? []).map((item) => ({ value: item.id, label: item.name }));
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });
};
